import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "@/libs/utils";

const badgeVariants = cva(
  "flex items-center justify-center rounded capitalize",
  {
    variants: {
      variant: {
        native: "bg-bhaptics-yellow text-yellow-hover-90",
        mod: "bg-blue-60 text-blue-hover-10",
        officialMod: "bg-bhaptics-yellow text-yellow-hover-90",
        "official-mod": "bg-bhaptics-yellow text-yellow-hover-90",
        new: "bg-blue-10 text-blue-hover-70",
        "new-text": "text-blue-30",
        sale: "bg-magenta-10 text-magenta-70",
        "sale-text": "text-magenta-30",
        best: "bg-purple-10 text-purple-60",
        upcoming: "bg-yellow-10 text-yellow-60",
        // 서버 `badges` 의 세 번째 값(`New`·`Upcoming` 과 같은 「상태 배지」 축).
        //
        // ⚠️ 디자이너 지정값이라 **명도가 형제들과 반대**다 — `new`·`upcoming` 은
        // 옅은 배경(`-10`)에 진한 글자(`-60`)인데, Beta 는 진한 배경(Teal-50 #009D9A)에
        // 옅은 글자(Teal-10 #D9FBFB)다. 형제를 보고 `bg-teal-10 text-teal-60` 으로
        // 「맞추는」 것이 오히려 시안 위반이다.
        // 모서리 4px 은 base 의 `rounded`(Tailwind 기본 0.25rem)가 이미 준다 —
        // 이 리포는 `borderRadius` 에서 `lg`/`md`/`sm` 만 덮고 DEFAULT 는 안 덮는다.
        beta: "bg-teal-50 text-teal-10",
        referral: "bg-green-50 text-white",
        "ai-powered": "bg-green-50 text-white",
        gamekey:
          "bg-[linear-gradient(90deg,#FF0096_0%,#FF6600_100%)] text-white",
        default: "bg-gray-10 text-gray-70",
      },
      size: {
        xs: "font-600 text-xs py-0 px-1 h-4",
        sm: "font-600 text-sm py-0.5 px-1.5 h-5",
        md: "font-500 text-base py-1 px-2",
      },
    },
    defaultVariants: {
      size: "md",
      variant: "default",
    },
  },
);

export interface BadgeProps
  extends
    React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, size, ...props }: BadgeProps) {
  return (
    <div
      className={cn(badgeVariants({ variant, size }), className)}
      {...props}
    />
  );
}

export { Badge, badgeVariants };
